export default "__VITE_ASSET__e50c804b__"